import React from 'react';
import PropTypes from 'prop-types';
import { ExtendedInfoSVG } from '../ExtendedInfo';
import { murmurhash } from '../../../lib/js/hash';

export default function DefinitionList({
  children = null,
  className,
  id = undefined,
  ariaHidden = null,
  definitionTerms,
}) {
  /**
   * Create a new <dt> Tag for every Term we have .
   */
  const createDT = dfTerm => {
    if (!dfTerm || !dfTerm.definitionDescriptions) {
      return null;
    }

    const createDD = dfDes => {
      return (
        <dd key={murmurhash(dfDes.class + dfDes.description)} className={dfDes.class}>
          {dfDes.description}
        </dd>
      );
    };

    // map all descriptions first and return both the <dt> tag with all <dd>'s
    const allDD = dfTerm.definitionDescriptions.map((dfDes, ddIndex) => createDD(dfDes, ddIndex));

    const id = murmurhash(dfTerm.class + dfTerm.term);
    return [
      <dt key={id} className={dfTerm.class}>
        {dfTerm.extendedInfoSVG ? (
          <span className="definition-list__term-symbol">
            <span className="definition-list__term-text">{dfTerm.term}</span>
            <span className="definition-list__symbol">
              <ExtendedInfoSVG
                helpText={dfTerm.extendedInfoSVG.helpText}
                tooltipPlacement={dfTerm.extendedInfoSVG.tooltipPlacement}
                svgSpriteID={dfTerm.extendedInfoSVG.svgSpriteID}
              />
            </span>
          </span>
        ) : (
          dfTerm.term
        )}
      </dt>,
      allDD,
    ];
  };

  return (
    <dl className={className} id={id} aria-hidden={ariaHidden}>
      {definitionTerms.map(dfTerm => createDT(dfTerm))}
      {children}
    </dl>
  );
}

const definitionTerm = PropTypes.shape({
  term: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  extendedInfoSVG: PropTypes.shape({
    helpText: PropTypes.string,
    tooltipPlacement: PropTypes.string,
    svgSpriteID: PropTypes.string,
  }),
  class: PropTypes.string,
  definitionDescriptions: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      class: PropTypes.string,
    })
  ),
});

DefinitionList.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string.isRequired,
  id: PropTypes.string,
  ariaHidden: PropTypes.bool,
  definitionTerms: PropTypes.arrayOf(definitionTerm).isRequired,
};
